<template>
  <el-card  v-if="selectedInvoice!=null && selectedInvoice.id!=null" v-loading="loading" class="box grow scrollable only-y" :style="height">
    <!-- Controls -->
    <div class="" style="position:relative;float:right;z-index:1000">
      <el-button type="primary" @click="$emit('edit')" :disabled="!canEditInvoice($can)" plain size="small" ><i class="el-icon-edit"></i></el-button>
      <el-badge :value="returnSignIfNotSent" class="ml-10">
        <el-button  type="primary" plain size="small" @click="openSendInvoiceDialog()" :disabled="!$can('write','Invoices')"><i class="el-icon-message"></i></el-button>
      </el-badge>

      <el-dropdown size="small" class=" ml-10">
        <el-button type="primary" size="small">
          {{$t('common.Actions')}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="addPayment" v-if="canAddPayment" :disabled="!$can('manage','Invoices')">{{$t('invoices.actions.addPayment')}}</el-dropdown-item>
          <el-dropdown-item @click.native="sendInvoice()" v-if="canMarkAsSent" :disabled="!$can('write','Invoices')">{{$t('invoices.actions.markAsSent')}}</el-dropdown-item>
          <el-dropdown-item @click.native="openCreditNoteEditor('CREATE')" :disabled="!$can('manage','Invoices') || selectedInvoice.status.code=='VOIDED'">{{$t('invoices.actions.createCreditNote')}}</el-dropdown-item>
          <el-dropdown-item @click.native="voidInvoice(selectedInvoice.id)" :disabled="!canVoidInvoice($can)">{{$t('invoices.actions.void')}}</el-dropdown-item>
          <el-dropdown-item @click.native="deleteInvoice" :disabled="!$can('manage','Invoices') || selectedInvoice.status.code!='VOIDED'">{{$t('invoices.actions.delete')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button  style="margin-left:10px;" plain size="small" @click="downloadInvoiceReport(selectedInvoice)" ><i class="el-icon-download"></i></el-button>
    </div>
    <!-- end controls -->
    <!-- begin title -->
    <el-row style="margin-bottom:10px;">
      <el-page-header @back="$emit('close');" style="float:left;">
        <div slot="title">
          <span class="hidden-sm-and-down"></span>
        </div>
        <div slot="content">
        <span class="fs-20">{{selectedInvoice.invNumber}}</span>
        </div>
      </el-page-header>
    </el-row>
    <!-- end title -->
    <!-- Begin tabs -->
    <el-tabs type="border-card" >
      <el-tab-pane>
        <span slot="label"><i class="el-icon-info"></i>{{$t('invoices.informations')}}</span>

        <el-row style="margin-left:10px;font-size:14px;" :gutter="10" v-if="selectedInvoice!=null">
          <el-col>
              <span class="fs-12 secondary-text" v-if="selectedInvoice.createdAt!=null">{{$t('common.createdAt')}} {{_moment(selectedInvoice.createdAt, 'LLL')}} {{ $t('common.by') }} {{selectedInvoice.createdBy.firstName}} {{selectedInvoice.createdBy.lastName}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-left:10px;font-size:14px;" :gutter="10" v-if="selectedInvoice!=null">
          <el-col>
              <span v-if="selectedInvoice.rep" class="fs-12 secondary-text">{{$t('invoices.repField')}} {{selectedInvoice.rep.firstName}} {{selectedInvoice.rep.lastName}}</span>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="mdi mdi-square-inc-cash"></i> {{$t('invoices.payments')}} <span v-if="selectedInvoice.payments!=null && selectedInvoice.payments.length>0">({{selectedInvoice.payments.length}})</span></span>
        <PaymentsTable :status="selectedInvoice.status" :payments="selectedInvoice.payments" @addPayment="addPayment" @deleted="handleDeletePayment" @edit="handleEditPayment" :currency="selectedInvoice.currency.code"></PaymentsTable>
      </el-tab-pane>
      <el-tab-pane >
        <span slot="label"><i class="el-icon-info"></i> {{ $t('invoices.appliedCredits') }} <span v-if="getCreditNotes!=null">({{getCreditNotes.length}})</span></span>
        <el-table
          :data="getCreditNotes"
          style="width: 100%"
          :empty-text="$t('credit_notes.noCreditNote')">
          <el-table-column  :label="$t('common.date')" width="120">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text">{{_moment(scope.row.createdAt,'l')}}</span>
            </template>
          </el-table-column>
          <el-table-column  :label="$t('credit_notes.creditNoteNumber')">
            <template slot-scope="scope">
                <el-button type="text" @click="openCreditNotes(scope.row.creditNote.id)"><span>{{scope.row.creditNote.crNumber}}</span></el-button>
            </template>
          </el-table-column>
          <el-table-column  :label="$t('credit_notes.credits')">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text">{{$n(scope.row.amount,'currency',selectedInvoice.currency.code)}}</span>
            </template>
          </el-table-column>
          <el-table-column width="60">
            <template slot-scope="scope">
              <el-button
                size="mini"
                circle
                type="danger"
                :disabled="!$can('manage','Invoice')"
                @click="deleteCreditNote({invoiceId:selectedInvoice.id, creditNoteId : scope.row.id})"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="salesOrders">
        <span slot="label"><i class="el-icon-s-order"></i> {{ $t('invoices.sales') }} <span v-if="selectedInvoice.salesOrders!=null && selectedInvoice.salesOrders.length>0">({{selectedInvoice.salesOrders.length}})</span></span>
        <SalesOrderTable :salesOrders="selectedInvoice.salesOrders"></SalesOrderTable>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="el-icon-document"></i> {{ $t('invoices.attachments') }} <span v-if="attachedFiles!=null && attachedFiles.length>0">({{attachedFiles.length}})</span></span>
        <el-upload
          class="upload-demo"
          :action="postAction"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :headers="getHeaders()"
          :on-preview="handlePreview"
          :on-exceed="handleExceed"
          :file-list="attachedFiles">
          <el-button size="small" type="primary" >{{$t('invoices.addAttachments')}}</el-button>
          <div slot="tip" class="el-upload__tip">{{$t('invoices.attachmentLimit')}}</div>
        </el-upload>
      </el-tab-pane>
    </el-tabs>
    <!--End tabs-->
    <!-- CREDIT Application -->
    <el-row class="m-20" :gutter="20" v-if="canShowCreditsLeft">
      <el-col>
        <span class="border fs-14 secondary-text p-10"><i class="mdi mdi-square-inc-cash"></i> {{$t('invoices.availableCreditsField')}} {{$n(selectedInvoice.customer.balance.credit,'currency', selectedInvoice.currency.code)}} <el-button type="text" @click="openCreditApplication" >{{$t('invoices.applyNow')}}</el-button></span>
      </el-col>
    </el-row>
    <!-- END CREDIT Application -->
    <el-divider></el-divider>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">
            {{$t('invoices.customerField')}} <PortausLink :label="customerName" :id="selectedInvoice.customer.id" path="/customers/"></PortausLink>
          </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.statusField')}} <el-tag size="small" :type="selectedInvoiceTagType" style="margin-left:10px;">{{$t("invoices.statuses."+selectedInvoice.status.code)}}</el-tag></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text" v-if="selectedInvoice.rep!=null">{{ $t('invoices.repField') }} {{selectedInvoice.rep.firstName}} {{selectedInvoice.rep.lastName}}</span>
          <span class="fs-14 secondary-text" v-else >{{ $t('invoices.repField') }} {{$t('common.notAvailable')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.dateField')}} <span class="fs-14 secondary-text" v-if="selectedInvoice.date!=null">{{_moment(selectedInvoice.date)}}</span></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.sentOnField')}} <span class="fs-14 secondary-text" v-if="selectedInvoice.sentAt!=null">{{_moment(selectedInvoice.sentAt)}}</span></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.invoiceTermField')}} <span class="fs-14 secondary-text">{{$t('invoices.terms.'+selectedInvoice.term.code)}}</span></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.dueDateField')}} <span class="fs-14 secondary-text" v-if="selectedInvoice.dueDate!=null">{{_moment(selectedInvoice.dueDate)}}</span></span>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.outstandingAmountField')}} <span class="fs-14 secondary-text">{{$n(selectedInvoice.balance.outstanding,'currency',selectedInvoice.currency.code)}}</span></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('invoices.paymentMethodsField')}} <span class="fs-14 secondary-text">{{paymentMethods}}</span></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="selectedInvoice.creditNote!=null">
          <span class="fs-14 secondary-text">{{$t('invoices.creditNoteField')}}   <PortausLink :label="selectedInvoice.creditNote.crNumber" :id="selectedInvoice.creditNote.id" path="/credit-notes/"></PortausLink></span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="selectedInvoice.reference!=null">
          <span class="fs-14 secondary-text">{{$t('invoices.referenceField')}} {{selectedInvoice.reference}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="selectedInvoice.invoiceNumberReference!=null">
          <span class="fs-14 secondary-text">{{$t('invoices.invoiceReferenceField')}}   {{selectedInvoice.invoiceNumberReference}}</span>
      </el-col>
    </el-row>
    <el-divider/>
    <el-row :gutter="20" justify="center">
      <el-col :xs="24" :sm="24" :md="124" :lg="12" :xl="12">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <span class="fs-14 secondary-text">{{$t('invoices.billedToField')}} </span>
              <span class="fs-14 secondary-text" v-if="selectedInvoice.customer.type==1 && billingContactName != null">{{billingContactName}}</span>
              <span class="fs-14 secondary-text" v-if="selectedInvoice.customer.type==0 ">{{customerName}}</span>
          </el-col>

        </el-row>
        <el-row style="margin-top:20px;margin-bottom:20px;">
          <el-col>
            <AddressCard  v-if="selectedInvoice.billingAddress!=null" :address="selectedInvoice.billingAddress" :ctrlVisible="false" :headerVisible="false"></AddressCard>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="124" :lg="12" :xl="12">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <span class="fs-14 secondary-text">{{$t('sales_orders.Deliver_to')}} : </span>
              <span class="fs-14 secondary-text" v-if="selectedInvoice.customer.type==1 && selectedInvoice.shippingContact!=null">{{getName(selectedInvoice.shippingContact)}}</span>
              <span class="fs-14 secondary-text" v-if="selectedInvoice.customer.type==0 ">{{customerName}}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px;">
          <el-col>
            <AddressCard  v-if="selectedInvoice.shippingAddress!=null" :address="selectedInvoice.shippingAddress" :ctrlVisible="false" :headerVisible="false"></AddressCard>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-divider/>
    <el-row :gutter="20">
      <el-table :data="selectedInvoice.lines" style="width:100%;" :empty-text="$t('invoices.noInvoiceLines')">
        <el-table-column :label="productLabel">
          <template slot-scope="scope">
            <SalesProductDefinition
              :product="scope.row.product"
              :inventory="scope.row.inventory"
              :vintage="getVintage(scope.row)"
              :item="scope.row.item"
              :description="scope.row.description"
              :showDetailProduct="false"/>
              <!-- <div v-if="scope.row.product.type==1">
                <span>
                  <el-link  @click="openProductDrawer(scope.row.product.id, scope.row.inventory.id)">{{scope.row.product.name}}</el-link>
                  <span v-if="scope.row.product.provider!=null">, <el-link @click="openCustomer(scope.row.product.provider.id)">{{getCustomerName(scope.row.product.provider, selectedInvoice.purchaseOrders != null && selectedInvoice.purchaseOrders.length > 0)}}</el-link></span>
                </span><br>
                <span v-if="scope.row.reference"><span class="fs-14 secondary-text">{{$t('invoices.lines.reference_code')}} {{formatBatchNumber(scope.row.item.reference, scope.row.inventory.code)}}</span><br></span>
                <span class="fs-14 secondary-text">{{scope.row.product.sku}}<br></span>
                <UnitFormatVolumeLabel :unit="scope.row.product.unit" :uvc="scope.row.product.uvc" :format="scope.row.product.format" :volume="scope.row.product.volume"></UnitFormatVolumeLabel>
              </div>
              <div v-else>
                  <span class="fs-14 ">{{scope.row.product.name}}</span><br>
                  <span class="fs-14 secondary-text">{{scope.row.product.sku}}</span>
                  <span class="fs-14 secondary-text" v-if="scope.row.description!=''"><br>{{scope.row.description}}</span>
              </div> -->
          </template>
        </el-table-column>
        <el-table-column prop="qty_ordered" :label="quantityLabel" width="120" align="center">
          <template slot-scope="scope">
                <span class="fs-14 secondary-text" >{{scope.row.qty}}<br> </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.price')" width="150" align="center">
          <template slot-scope="scope">
              <div v-for="(price, index) in scope.row.prices" :key="index">
                <span class="fs-14 secondary-text" >{{$n(price.price,'currency',selectedInvoice.currency.code)}}<br> </span>
              </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.rebate')" width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.discount != null && scope.row.discount.type==1" class="fs-14 secondary-text" >{{scope.row.discount.value}}%</span>
            <span v-else>
              <span v-if="scope.row.discount == null || scope.row.discount.amount==null"> -- </span>
              <div v-else>
                <span v-if="scope.row.discount != null && scope.row.discount.netType=='UNIT'">{{scope.row.discount.value}}$ / b.</span>
                <span v-if="scope.row.discount != null && scope.row.discount.netType=='NET'">{{scope.row.discount.value}}$</span>
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Total" width="150" align="right">
          <template slot-scope="scope">
                <span class="fs-14 secondary-text" >{{$n(scope.row.subTotalBrut,'currency',selectedInvoice.currency.code)}}</span>
                <span v-if="scope.row.discount!=null && scope.row.discount.amount!=null" class="fs-14 secondary-text" ><br>({{$n(scope.row.discount.amount,'currency')}}) </span>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <table style="width:100%;margin-top:20px;">
            <tr>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.subTotalField')}} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedInvoice.subTotal,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
            <tr v-if="selectedInvoice.discount != null">
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.rebateField')}}</td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">
                <span v-if="selectedInvoice.discount.type==1">({{selectedInvoice.discount.value}}%) ({{$n(selectedInvoice.discount.amount, 'currency')}})</span>
                <span v-else>
                  <span v-if="selectedInvoice.discount.netType=='TOTAL'">({{$n(selectedInvoice.discount.value, 'currency')}})</span>
                </span>
              </td>
            </tr>
            <tr v-for="(tax, index) in selectedInvoice.taxes" :key="index">
              <td class="fs-14 secondary-text" style="text-align:right;">{{tax.name || tax.label}} ({{tax.number || tax.taxNumber}}) : </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.totalField')}} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedInvoice.total,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
            <tr v-if="selectedInvoice.balance.credited > 0">
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.creditsApplied')}} </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(selectedInvoice.balance.credited,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
            <tr v-if="selectedInvoice.balance.paid>0">
              <td class="fs-14 secondary-text" style="text-align:right;">{{$t('invoices.paidAmound')}} </td>
              <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(selectedInvoice.balance.paid,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
            <tr>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.outstandingAmountField')}} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(selectedInvoice.balance.outstanding,'currency',selectedInvoice.currency.code)}}</td>
            </tr>
        </table>
      </el-row>
    </el-row>
    <el-row :gutter="20" v-if="selectedInvoice.notes!=null && selectedInvoice!==''">
      <h5>Notes</h5>
      <el-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
          <span class="fs-14 secondary-text" v-html="selectedInvoice.notes"></span>
      </el-col>
    </el-row>
    <ProductDetailDrawer :productId="selectedProductId" :inventoryId="selectedInventoryId" direction="ltr" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer"></ProductDetailDrawer>
    <sendInvoiceDialog v-if="selectedInvoice.customer && selectedInvoice.customer.language" :visible="sendInvoiceDialog" :invoice="selectedInvoice" :language="selectedInvoice.customer.language.code" @close="closeSendInvoiceDialog" @sent="invoiceSent"></sendInvoiceDialog>
    <AddPaymentsDialog :visible="addPaymentsDialogVisible" :invoices="[selectedInvoice]" :customerId="selectedInvoice.customer.id" direction="rtl" :paymentToEdit="paymentToEdit" @close="closeAddPaymentsDialog"  @paid="updateInvoicePayment"></AddPaymentsDialog>
    <CreditNoteEditor :visible="creditNoteEditorVisible" :invoice="selectedInvoice" @close="closeCreditNoteEditor" @created="creditNoteCreated"></CreditNoteEditor>
    <CreditNoteApplicationDrawer :invoice="selectedInvoice" :balanceToPay="selectedInvoice.balance.outstanding" :visible="creditNoteApplicationDrawerVisible" @close="closeCreditApplication" @apply="applyCreditNotes"></CreditNoteApplicationDrawer>
  </el-card>
</template>
<script>

import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import sendInvoiceDialog from '@/components/invoice/send-invoice-dialog.vue'
import AddPaymentsDialog from '@/components/payments/add-payments-dialog.vue'
import PaymentsTable from '@/components/payments/payments-table-v2.vue'
import CreditNoteEditor from '@/components/creditNote/credit-note-editor.vue'
import CreditNoteApplicationDrawer from '@/components/creditNote/credit-note-application-drawer.vue'
import AddressCard from '@/components/address/Address-Card'
import axios from 'axios'
import salesOrderApi from '@/services/API/sales-order'
import SalesOrderTable from '@/components/salesOrder/sales-order-table.vue'
import PortausLink from '@/components/portaus-link'
import customerUtils from '@/utils/customer-util'
import ProductUtil from '@/utils/product-util'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import SalesProductDefinition from '@/components/salesOrder/sales-product-definition'
export default {
  name : 'Invoice-view',
  props : {
  },
  data() {
    return {
      window : {
        width:0,
        height : 0,
      },
      selectedProductId : null,
      selectedInventoryId : null,
      productDetailDrawerVisible : false,
      sendInvoiceDialog : false,
      addPaymentsDialogVisible : false,
      creditNoteEditorVisible : false,
      creditNoteApplicationDrawerVisible :false,
      // salesOrders : [],
      paymentToEdit : null,
      customerInfos : null,
    };
  },components : {
    AddressCard,
    ProductDetailDrawer,
    sendInvoiceDialog,
    AddPaymentsDialog,
    PaymentsTable,
    CreditNoteEditor,
    CreditNoteApplicationDrawer,
    SalesOrderTable,
    PortausLink,
    UnitFormatVolumeLabel,
    SalesProductDefinition
  },
  watch : {
    // selectedInvoice: function (val) {
    //   this.salesOrders= [];
    //   if(val.sales_order)this.salesOrders.push(val.sales_order);
    // }
  },
  methods : {
    getVintage (line) {
      return _.get(line, 'item.extraInfo.vintage');
    },
    formatBatchNumber(batchNumber, inventoryCode){
      return ProductUtil.formatBatchNumber(batchNumber, inventoryCode === 'IP');
    },
    handleEditPayment({index, payment}){
      this.paymentToEdit=payment;
      this.openPaymentDialog();
    },
    deleteInvoice(){
      this.deleteSelectedInvoice()
        .then(()=>{
          this.$emit('close');
        })
    },
    getCustomerName(customer, force){
      return customerUtils.customerName(customer.name, customer.usualName, force);
    },
    getName(contact){
      if((contact.firstName==null || contact.firstName==='') && contact.lastName==null || contact.lastName===''){
        return "Unnamed contact" + " ("+contact.email+")";
      }
      return contact.firstName + " " + contact.lastName;
    },
    applyCreditNotes(creditNotes){
      this.applyCreditNotesToSelectedInvoice(creditNotes);
    },
    openCreditApplication(){
      this.creditNoteApplicationDrawerVisible=true;
    },
    closeCreditApplication(){
      this.creditNoteApplicationDrawerVisible=false;
    },
    creditNoteCreated(creditNote){
      this.updateSelectedInvoice();
    },
    handleDeletePayment({index, payment}){
      let msg = _.isEmpty(payment.creditNotes) ? this.$i18n.t('invoices.confirmDeletePayment') : this.$i18n.t('invoices.confirmDeletePaymentWithCreditNote');
      this.$confirm(msg, { confirmButtonText:'Oui',cancelButtonText:'Annuler'})
        .then(()=>{
          this.deleteSelectedInvoicePayment({index, payment})
            .then(()=>{
              this.$message.success(this.$i18n.t('invoices.paymentDeletedConfirmation'));
            }).catch(err=>{
              this.$message.error(this.$i18n.t('errors.SYSTEM'));
            })
        }).catch(err=>{/* do nothing*/})

    },
    updateInvoicePayment({payment, invoices}){
      this.invalidateSalesOrderList();
      this.updateSelectedInvoice()
    },
    openPaymentDialog(){
      this.addPaymentsDialogVisible=true;
    },
    addPayment(){
      this.openPaymentDialog();
    },
    closeAddPaymentsDialog(){
      this.paymentToEdit=null;
      this.addPaymentsDialogVisible=false;
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    openCustomerInvoices(customerId){
      var index='/customers/'+customerId+"?activeTab=3";
			this.$router.push(index);
    },
    openSendInvoiceDialog(){
      if(!this.selectedInvoice.customer.onlineInvoicingInd){
        this.$confirm(this.$i18n.t('invoices.manual_sending_instruction'), this.$i18n.t('invoices.manual_sending_instruction_title'),{
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Annuler',
                  type: 'warning'
                }).then(()=>{
                  this.markAs({message : 'Le statut de la facture a été modifié avec succès!', statusCode : 'TO_SEND'})
                }).catch(err=>{/*do nothing*/})
      }else{
        this.sendInvoiceDialog=true;
      }

    },
    closeSendInvoiceDialog(){
      this.sendInvoiceDialog=false;
    },
    openCreditNoteEditor(action){
      if(action=='CREATE'){
         this.validateCreationOfCreditNote()
          .then(valid=>{
            if(valid){
              this.creditNoteEditorVisible=true;
            }
          })
      }else{
        this.creditNoteEditorVisible=true;
      }

    },
    closeCreditNoteEditor(){
      this.creditNoteEditorVisible=false
    },
    invoiceSent(){
      this.updateSelectedInvoice();
      // console.log("Invoice sent");
      // if(this.selectedInvoice.sent_at==null) {
        // console.log("markAS Sent");
        // this.markAs({statusCode : 'SENT',message:"L'avis de facturation a été envoyé ave succès"});
      // }

    },
    openProductDrawer(productId, inventoryId){
      this.selectedProductId = productId;
      this.selectedInventoryId = inventoryId;
      this.productDetailDrawerVisible = true;
    },
    closeProductDetailDrawer(){
      this.selectedProductId = null;
      this.selectedInventoryId = null;
      this.productDetailDrawerVisible = false;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleRemove(file, fileList) {
      this.deleteInvoiceFile({invoiceId : file.invoiceId, id : file.id});
    },
    handlePreview(file) {
      // this.loading=true
      // console.log(file);
      axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+file.invoiceId+"/files/"+file.id,{responseType: 'arraybuffer'})
  				.then(response=>{
            // console.log("response : ", response);
            // console.log("headers : ", response.headers);
            var headers = response.headers;
            var blob = new Blob([response.data],{type:headers['content-type']});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = file.name;
            link.click();
            // this.loading=false;
  				});
    },
    handleExceed(files, fileList) {
      this.$message.warning(`La limite est 3, vous avez choisi ${files.length} fichiers, soit ${files.length + fileList.length} au total.`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Supprimer le fichier ${ file.name } ?`, {confirmButtonText: 'Oui',cancelButtonText: 'Annuler',});
    },
    getHeaders(){
      var headers = {};
      headers.Authorization = localStorage.getItem('access-token')
      return headers;
    },
    openCreditNotes(id){
			var index = '/credit-notes/' + id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		},
    ...mapActions('salesOrders',['invalidateSalesOrderList']),
    ...mapActions('invoices',['markAs','downloadInvoiceReport','deleteInvoiceFile','deleteSelectedInvoicePayment','updateSelectedInvoice','validateCreationOfCreditNote', 'deleteCreditNote','applyCreditNotesToSelectedInvoice','deleteSelectedInvoice','voidInvoice','sendInvoice'])
  },
  computed : {
    productLabel () {
      return `${this.$i18n.t('invoices.product')} (${this.nbLines})`;
    },
    quantityLabel () {
      return `${this.$i18n.t('invoices.quantity')} (${this.totalQuantities})`;
    },
    nbLines () {
      return this.selectedInvoice.lines.length;
    },
    totalQuantities (){
      let count = 0;
      _.forEach(this.selectedInvoice.lines, (l) => {
        count += l.qty;
      })
      return count;
    },
    customerName(){
      if (this.selectedInvoice == null) return null;
      return customerUtils.customerName(this.selectedInvoice.customer.name, this.selectedInvoice.customer.usualName);
    },
    billingContactName(){
      if (this.selectedInvoice.billingContact != null) {
        return this.getName(this.selectedInvoice.billingContact)
      }
      return null;
    },
    shippingContactName(){
      if (this.selectedInvoice.shippingContact != null) {
        return this.getName(this.selectedInvoice.shippingContact)
      }
      return null;
    },
    postAction(){
      return process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+this.selectedInvoice.id+"/files";
    },
    height(){
      return "height :"+(this.window.height-200) + "px"
    },
    paymentMethods(){
      let methods = '';
      _.forEach(this.selectedInvoice.paymentTypes, (option, key)=>{
        if(key>0)methods += ', ';
        methods = methods + this.$i18n.t('invoices.'+option.code);
      })
      return methods;
      // return this.$i18n.t('invoices.'+'CREDIT_CARD');
    },
    ...mapState('invoices',['loading', 'selectedInvoice']),
    ...mapGetters('invoices',['selectedInvoiceTagType','canEditInvoice','canMarkAsSent','canAddPayment','canVoidInvoice','attachedFiles','getCreditItemLineTotal','getCreditNotes','canShowCreditsLeft','returnSignIfNotSent'])
  },
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();

  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.strike{
  text-decoration: line-through;
}

.addedItem{
  color : #5f8fdf;
}
.modifiedItem{
  color : #ec205f;
}

.el-alert{
  margin-bottom:10px;
}

.page-salesOrder{


	.salesOrder {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 800px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.salesOrder-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				 float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				overflow: hidden;
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.salesOrder-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.deliveryDate{
				display: block;
				float:right;
				margin-top:20px;

				& > * {
					margin: 0;
				}
				.infoDelivery {
					font-weight:bold;

				}


			}

			.notes {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.salesOrder-bottom {

			table {
				width: 100%;
				border-collapse: collapse;

				th {
					// text-align: right;
					// padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					// padding-bottom: 5px;
					border-bottom: 1px solid #EEE;
					font-size:13px;
          vertical-align:top;


					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
          padding:0px;
					padding-top: 5px;
          text-align:right;
          &:first-child {
						text-align: right;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}
			}

		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 900px) {
	.page-salesOrder {
		.salesOrder {
			.salesOrder-middle {
				.notes {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;

				}
				.info {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;


				}
			}
			.salesOrder-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-salesOrder {

		.salesOrder {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
